import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthShell";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { user, refreshUser } = useAuth();
  const [state, setState] = useState({ status: "loading", message: "" });
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => { setState({ status: "done" }); refreshUser(); })
      .catch((e) => setState({ status: "error", message: errorMessage(e, "This confirmation link is invalid or has expired.") }));
  }, [params, refreshUser]);

  const cta = user ? ["/dashboard", "Go to your dashboard"] : ["/login", "Log in"];
  const content = {
    loading: [Loader2, "Confirming your email...", "This only takes a second."],
    done: [CheckCircle2, "Email confirmed", "Your quote link is live and your 14-day free trial has started."],
    error: [XCircle, "Link not valid", state.message],
  }[state.status];
  const [Icon, title, sub] = content;

  return (
    <AuthShell title={title} sub={sub} footer={null}>
      <div data-testid="verify-email-page" data-status={state.status}>
        <Icon className={`h-10 w-10 ${state.status === "loading" ? "animate-spin text-slate-400" : state.status === "done" ? "text-emerald-600" : "text-red-500"}`} />
        {state.status !== "loading" && (
          <Link to={cta[0]} data-testid="verify-email-continue-link"
            className="mt-6 flex h-14 w-full items-center justify-center rounded-xl bg-slate-900 text-lg font-semibold text-white">{cta[1]}</Link>
        )}
      </div>
    </AuthShell>
  );
}
